// @flow
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React, { useEffect } from 'react';

import ContactUsSection from '_components/ContactUsSection';
import HeaderSection from '_components/HeaderSection';
import Layout from '_components/Layout';
import useAnalytics, { event } from '_hooks/useAnalytics';
import HeaderBgImage from '_images/bg-header-contact-us.jpg';

const Faq = (): React$Node => {
  const { t } = useTranslation();
  const { track } = useAnalytics();

  useEffect(() => {
    track({
      group: event.group.ContactUs,
      action: event.action.Viewed,
    });
  }, [track]);

  return (
    <Layout floatingNavbar={false} footerTrianglePosition="right">
      <HeaderSection
        title={t('ContactUs_Title')}
        description={t('ContactUs_Description')}
        backgroundImage={HeaderBgImage}
      />
      <ContactUsSection />
    </Layout>
  );
};

export default Faq;
